import React from 'react';
import { currencyFormatter } from '../_helpers/UtilityHelpers';

export const PriceColumnFormatter = (cellContent, row) => <>{currencyFormatter(parseInt(cellContent))}</>;
